import Img1 from '../../assets/images/Modimeditex/Abdominal Pain and Injury Support/Abdominal Belt 3 panel.jpg';
import Img2 from '../../assets/images/Modimeditex/Abdominal Pain and Injury Support/Abdominal Belt 9 Inches With Extra Support.jpg';
import Img3 from '../../assets/images/Modimeditex/Abdominal Pain and Injury Support/Abdominal Belt 9 Inches With Extra Support(1).jpg';
import Img4 from '../../assets/images/Modimeditex/Abdominal Pain and Injury Support/Abdominal Belt 10 Inches With Extra Support.jpg';
import Img5 from '../../assets/images/Modimeditex/Abdominal Pain and Injury Support/Hernia Belt (Female).jpg';
import Img6 from '../../assets/images/Modimeditex/Abdominal Pain and Injury Support/Hernia Belt (Male).jpg';
import Img7 from '../../assets/images/Modimeditex/Abdominal Pain and Injury Support/Main_Image.png';
import Img8 from '../../assets/images/Modimeditex/Abdominal Pain and Injury Support/Pelvic Binder.png';
import Img9 from '../../assets/images/Modimeditex/Abdominal Pain and Injury Support/Scrotal Support.png';
import Img10 from '../../assets/images/Modimeditex/Ankle pain and injury support/Ankle Binder.jpg';
import Img11 from '../../assets/images/Modimeditex/Ankle pain and injury support/Ankle Brace.png';
import Img12 from '../../assets/images/Modimeditex/Ankle pain and injury support/Ankle Support (3D).jpg';
import Img13 from '../../assets/images/Modimeditex/Ankle pain and injury support/Ankle Support (4 W).jpg';
import Img14 from '../../assets/images/Modimeditex/Ankle pain and injury support/Ankle Support With Binder.jpg';
import Img15 from '../../assets/images/Modimeditex/Ankle pain and injury support/Foot Drop Splint.jpg';
import Img16 from '../../assets/images/Modimeditex/Back pain and injury support/Hyper Extension Brace or ASH Brace.jpg'
import Img17 from '../../assets/images/Modimeditex/Back pain and injury support/L.S. Contoured Belt.png';
import Img18 from '../../assets/images/Modimeditex/Back pain and injury support/L.S. Corset Belt.png';
import Img19 from '../../assets/images/Modimeditex/Back pain and injury support/Lumbar Sacro Belt (Neo).png';
import Img20 from '../../assets/images/Modimeditex/Back pain and injury support/Lumbar Sacro Belt.png';
import Img21 from '../../assets/images/Modimeditex/Back pain and injury support/Posture Corrector Belt Long.png';
import Img22 from '../../assets/images/Modimeditex/Back pain and injury support/Posture Corrector Belt Short.png';
import Img23 from '../../assets/images/Modimeditex/Back pain and injury support/Taylor_s Brace or Dorsolumbar Brace.png';
import Img24 from '../../assets/images/Modimeditex/Cervical pain and injury support/Cervical Collar.jpg';
import Img25 from '../../assets/images/Modimeditex/Cervical pain and injury support/Hard Collar with Heigth Adjustable.jpg';
import Img26 from '../../assets/images/Modimeditex/Cervical pain and injury support/Philadelphia Collar.jpg';
import Img27 from '../../assets/images/Modimeditex/Cervical pain and injury support/Soft collar.jpg';
import Img28 from '../../assets/images/Modimeditex/Chest, Rib & Shoulder pain and injury support/Arm Sling pouch.png';
import Img29 from '../../assets/images/Modimeditex/Chest, Rib & Shoulder pain and injury support/Chest Binder.png';
import Img30 from '../../assets/images/Modimeditex/Chest, Rib & Shoulder pain and injury support/Clavicle Brace.png';
import Img31 from '../../assets/images/Modimeditex/Chest, Rib & Shoulder pain and injury support/Rib Belt (Female).png';
import Img32 from '../../assets/images/Modimeditex/Chest, Rib & Shoulder pain and injury support/Rib Belt (Male).png';
import Img33 from '../../assets/images/Modimeditex/Chest, Rib & Shoulder pain and injury support/Shoulder Immobilizer (Cloth).png';
import Img34 from '../../assets/images/Modimeditex/Chest, Rib & Shoulder pain and injury support/Shoulder Immobilizer with Cap (Elastic).png';
import Img35 from '../../assets/images/Modimeditex/Chest, Rib & Shoulder pain and injury support/Shoulder Support.png';
import Img36 from '../../assets/images/Modimeditex/Elbow pain and injury support/Elbow Support (2W).jpg';
import Img37 from '../../assets/images/Modimeditex/Elbow pain and injury support/Elbow Support (3D).jpg';
import Img38 from '../../assets/images/Modimeditex/Elbow pain and injury support/Elbow Support (4W).jpg';
import Img39 from '../../assets/images/Modimeditex/Elbow pain and injury support/Tennis Elbow Support.jpg';
import Img40 from '../../assets/images/Modimeditex/Exercise Aid/Exercise Ball (GEL).jpg';
import Img41 from '../../assets/images/Modimeditex/Exercise Aid/Weigth Cuff.jpg';
import Img42 from '../../assets/images/Modimeditex/Foot care product/6.jpg';
import Img43 from '../../assets/images/Modimeditex/Foot care product/114.jpg';
import Img44 from '../../assets/images/Modimeditex/Foot care product/115.jpg';
import Img45 from '../../assets/images/Modimeditex/Foot care product/Heel Cushion.jpg';
import Img46 from '../../assets/images/Modimeditex/Foot care product/Heel Pad.jpg';
import Img47 from '../../assets/images/Modimeditex/Foot care product/Heel Socks (Anti Crack Heel).jpg';
import Img48 from '../../assets/images/Modimeditex/Foot care product/Medial Arch Support.jpg';
import Img49 from '../../assets/images/Modimeditex/Foot care product/Toe Saprater.jpg';
import Img50 from '../../assets/images/Modimeditex/Fracture Aids/Cast Shoe.jpg';
import Img51 from '../../assets/images/Modimeditex/Fracture Aids/Cotton Roll.jpg';
import Img52 from '../../assets/images/Modimeditex/Fracture Aids/Elastic Adhesive Bandage.jpg';
import Img53 from '../../assets/images/Modimeditex/Fracture Aids/POP Bandage.jpg';
import Img54 from '../../assets/images/Modimeditex/Fracture Aids/Stockinette Roll.jpg';
import Img55 from '../../assets/images/Modimeditex/Hot and Cold Therapy/Heating pad.jpg';
import Img56 from '../../assets/images/Modimeditex/Hot and Cold Therapy/Pocket Warm Bag.jpg';
import Img57 from '../../assets/images/Modimeditex/Hot and Cold Therapy/Rubber Hot Water Bottle.jpg';
import Img58 from '../../assets/images/Modimeditex/Hot and Cold Therapy/Warm Bag.jpg';
import Img59 from '../../assets/images/Modimeditex/Knee pain and injury support/Below Knee Stockings (4 W).png';
import Img60 from '../../assets/images/Modimeditex/Knee pain and injury support/Calf Support.png';
import Img61 from '../../assets/images/Modimeditex/Knee pain and injury support/Knee Cap (2 W).png';
import Img62 from '../../assets/images/Modimeditex/Knee pain and injury support/Knee Cap (3D).png';
import Img63 from '../../assets/images/Modimeditex/Knee pain and injury support/Knee Cap (4 W).png';
import Img64 from '../../assets/images/Modimeditex/Knee pain and injury support/Knee Cap Open Patella.png';
import Img65 from '../../assets/images/Modimeditex/Knee pain and injury support/Knee Immobilizer Long (19_).png';
import Img66 from '../../assets/images/Modimeditex/Knee pain and injury support/Knee Immobilizer Short (14_).png';
import Img67 from '../../assets/images/Modimeditex/Knee pain and injury support/Knee Support With Hinges.png';
import Img68 from '../../assets/images/Modimeditex/Knee pain and injury support/Knee Wrap Open Patella.png';
import Img69 from '../../assets/images/Modimeditex/Knee pain and injury support/R.O.M. Knee Brace.png';
import Img70 from '../../assets/images/Modimeditex/Knee pain and injury support/Thigh Support.png';
import Img71 from '../../assets/images/Modimeditex/Knee pain and injury support/Tibia Brace.png';
import Img72 from '../../assets/images/Modimeditex/Knee pain and injury support/Varicose Vein stockings (4 W).png';
import Img73 from '../../assets/images/Modimeditex/Makes your life comfortable/126.jpg';
import Img74 from '../../assets/images/Modimeditex/Makes your life comfortable/Cervical Pillow.jpg';
import Img75 from '../../assets/images/Modimeditex/Makes your life comfortable/Chair Back Rest Long.jpg';
import Img76 from '../../assets/images/Modimeditex/Makes your life comfortable/Cocyyx Cushion.jpg';
import Img77 from '../../assets/images/Modimeditex/Makes your life comfortable/Half Back Rest.jpg';
import Img78 from '../../assets/images/Modimeditex/Makes your life comfortable/Neck Pillow (Raised U Shape).jpg';
import Img79 from '../../assets/images/Modimeditex/Makes your life comfortable/Pregnancy Pillow (fiber).jpg';
import Img80 from '../../assets/images/Modimeditex/Makes your life comfortable/Wedge Pillow.jpg';
import Img81 from '../../assets/images/Modimeditex/Wrist, Finger pain and injury support/Cot Finger Splint.jpg'
import Img82 from '../../assets/images/Modimeditex/Wrist, Finger pain and injury support/Thumb Spica Splint.jpg'
import Img83 from '../../assets/images/Modimeditex/Wrist, Finger pain and injury support/Wrist & Forarm Splint.jpg'
import Img84 from '../../assets/images/Modimeditex/Wrist, Finger pain and injury support/Wrist Band With Double Lock.jpg'
import Img85 from '../../assets/images/Modimeditex/Wrist, Finger pain and injury support/Wrist Band With Single Lock.jpg'
import Img86 from '../../assets/images/Modimeditex/Wrist, Finger pain and injury support/Wrist Band With Thumb Loop.jpg'
import Img87 from '../../assets/images/Modimeditex/Wrist, Finger pain and injury support/Wrist Band With Thumb Support (Neo).png'
import Img88 from '../../assets/images/Modimeditex/Wrist, Finger pain and injury support/Wrist Splint.jpg'
import Img89 from '../../assets/images/Mohini Health/20210618104530.png';
import Img90 from '../../assets/images/Mohini Health/Absorbent_Cotton_Wool.png';
import Img91 from '../../assets/images/Mohini Health/Adhesive_Bandage.png';
import Img92 from '../../assets/images/Mohini Health/Capsicum_Plasters.png';
import Img93 from '../../assets/images/Mohini Health/Crepe_Bandage.png';
import Img94 from '../../assets/images/Mohini Health/Ear_Buds.png';
import Img95 from '../../assets/images/Mohini Health/Face_Wipe.png';
import Img96 from '../../assets/images/Mohini Health/First-Aid_Bandage.png';
import Img97 from '../../assets/images/Mohini Health/Gamjee_Roll.png';
import Img98 from '../../assets/images/Mohini Health/Gauze_Balls.png';
import Img99 from '../../assets/images/Mohini Health/Gauze_Bandage.png';
import Img100 from '../../assets/images/Mohini Health/Gauze_Roll.png';
import Img101 from '../../assets/images/Mohini Health/Gauze_Swabs (1).png';
import Img102 from '../../assets/images/Mohini Health/Gauze_Swabs.png';
import Img103 from '../../assets/images/Mohini Health/Laparotomy_Sponge-Abdominal_Gauze.png';
import Img104 from '../../assets/images/Mohini Health/Make_Up_Pads.png';
import Img105 from '../../assets/images/Mohini Health/Non-Absorbent_Cotton_Wool.png';
import Img106 from '../../assets/images/Mohini Health/Non-Woven_Surgical_Tape.png';
import Img107 from '../../assets/images/Mohini Health/Ortho_Wrap.png';
import Img108 from '../../assets/images/Mohini Health/Orthopaedic_Casting_Tape.png';
import Img109 from '../../assets/images/Mohini Health/Paraffin_Wax.png';
import Img110 from '../../assets/images/Mohini Health/Under_Pads.png';
import Img111 from '../../assets/images/Mohini Health/Wound_Plasters.png';
import Img112 from '../../assets/images/Mohini Health/Zig-Zag_Cotton_Wool.png';
import Img113 from '../../assets/images/Kohinoor/1-CREPE-BANDAGE.png';
import Img114 from '../../assets/images/Kohinoor/2-ELASTIC-CREPE-BANDAGE.png';
import Img115 from '../../assets/images/Kohinoor/3-ELASTIC-ADHESIVE-BANDAGE.png';
import Img116 from '../../assets/images/Kohinoor/4-CANNULA-FIXATOR.png';
import Img117 from '../../assets/images/Kohinoor/6-ELASTIC-GAUZE-BANDAGE.png';
import Img118 from '../../assets/images/Kohinoor/7-GAUZE-SWAB-NON-STERILE.png';
import Img119 from '../../assets/images/Kohinoor/8-GAUZE-SWAB-STERILE-1200x800.png';
import Img120 from '../../assets/images/Kohinoor/10-COMBINE-DRESSING.png';
import Img121 from '../../assets/images/Kohinoor/14-ORTHO-BANDAGE.png';
import Img122 from '../../assets/images/Kohinoor/15-GUMJEE-ROLL.png';
import Img123 from '../../assets/images/Kohinoor/18-CAST-PADDING-ROLL.png';
import Img124 from '../../assets/images/Kohinoor/19-POP-BANDAGE.png';
import Img125 from '../../assets/images/Kohinoor/20-FIBREGLASS-ONLINE-KHULO-PHOTO-LEVO.png';
import Img126 from '../../assets/images/Kohinoor/21-PARAFFIN-GAUZE-STICKER-UPAR-AND-SINGLE-PCS.png';
import Img127 from '../../assets/images/Kohinoor/23-ORTHOSTOCKINETT.png';
import Img128 from '../../assets/images/Kohinoor/EYE-PAD-DESIGN-CHANGE.png';
import Img129 from '../../assets/images/assure/Absorbent-Bandage-Cloth.jpg';
import Img130 from '../../assets/images/assure/Combine-Dressing-Dressing-Pad-.jpg';
import Img131 from '../../assets/images/assure/Cotton-Crepe-Bandage.jpg';
import Img132 from '../../assets/images/assure/Disposable-Gauze-Swab.jpg';
import Img133 from '../../assets/images/assure/DRESSING-PAD.jpg';
import Img134 from '../../assets/images/assure/Elastic-Adhesive-Bandage.jpg';
import Img135 from '../../assets/images/assure/Gamjee-Roll.jpg';
import Img136 from '../../assets/images/assure/Hydrocolloid-Wound-Dressing.jpg';
import Img137 from '../../assets/images/assure/IV-Cannula-Fixator.jpg';
import Img138 from '../../assets/images/assure/Paraffin-Gauze-Dressing-Sterile.jpg';
import Img139 from '../../assets/images/assure/Paraffin-Gauze-Dressing.jpg';
import Img140 from '../../assets/images/assure/Plaster-of-Paris-Bandage.jpg';
import Img141 from '../../assets/images/assure/Silver-Sulfadiazine-Tulle-Dressing.jpg';
import Img142 from '../../assets/images/assure/Soft-Roll-Padding-Orthopedic-Bandage.jpg';
import Img143 from '../../assets/images/assure/Surgical-Abdominal-Pad.jpg';
import Img144 from '../../assets/images/assure/Surgical-Cotton-Roll.jpg';
import Img145 from '../../assets/images/assure/Surgical-Lint-Cloth.jpg';
import Img146 from '../../assets/images/assure/Zinc-oxide-plaster-adhesive-tape.jpg';
import Img147 from '../../assets/images/Healthcare & Diagnostic Equipment/10 Liter Oxygen Concentrator.png'
import Img148 from '../../assets/images/Healthcare & Diagnostic Equipment/Adult Oxygen Mask with Tubing.png'
import Img149 from '../../assets/images/Healthcare & Diagnostic Equipment/Aluminum Oxygen Cylinder.png'
import Img150 from '../../assets/images/Healthcare & Diagnostic Equipment/Compressor Nebulizer Machine.png'
import Img151 from '../../assets/images/Healthcare & Diagnostic Equipment/Nebulizer Mask with Medication Chamber and Tubing.png'
import Img152 from '../../assets/images/Surgical Instruments & Examination Tools/Aneroid Blood Pressure Monitor (Manual Sphygmomanometer).png'
import Img153 from '../../assets/images/Surgical Instruments & Examination Tools/Dual Head Acoustic Stethoscope.png'
import Img154 from '../../assets/images/Weighing Scales & Measurement Devices/Analog Round Mechanical Weighing Scale.png'
import Img155 from '../../assets/images/Weighing Scales & Measurement Devices/Aneroid Blood Pressure Monitor (Manual Sphygmomanometer).png'
import Img156 from '../../assets/images/Weighing Scales & Measurement Devices/Digital Baby Weighing Scale (Infant).png'
import Img157 from '../../assets/images/Weighing Scales & Measurement Devices/Digital Tempered Glass Weighing Scale.png'
import Img158 from '../../assets/images/Weighing Scales & Measurement Devices/Dual Head Acoustic Stethoscope.png'
import Img159 from '../../assets/images/Weighing Scales & Measurement Devices/Mommy & Baby Digital Weighing Scale.png'
import Img160 from '../../assets/images/Weighing Scales & Measurement Devices/Victoria DX Personal Weighing Scale.png'
import Img161 from '../../assets/images/apparel_wear/lab_coat.png'
import Img162 from '../../assets/images/apparel_wear/surgical_cap.png'
import Img163 from '../../assets/images/apparel_wear/surgical_glove.png'
import Img164 from '../../assets/images/apparel_wear/surgical_gown.png'
import Img165 from '../../assets/images/apparel_wear/surgical_shield.png'
import Img166 from '../../assets/images/apparel_wear/lab_coat.png'
import Img167 from '../../assets/images/apparel_wear/surgical_cap.png'
import Img168 from '../../assets/images/apparel_wear/surgical_glove.png'
import Img169 from '../../assets/images/apparel_wear/surgical_gown.png'
import Img170 from '../../assets/images/apparel_wear/surgical_shield.png'



export const categories = [
  {
    id: "health-care",
    name: "Healthcare & Diagnostic Equipment",
    description:"Advanced diagnostic and monitoring equipment used in hospitals and clinics.",
    products: [
      
     { name:"Oxygen Concentrator Machine", image: Img147},
     { name:"Oxygen Mask with Tubing", image:Img148},
     { name:"Medical Oxygen Cylinders Set", image:Img149}, 
     { name:"Portable Nebulizer Machine", image:Img150},
     { name:"Nebulizer Mask Kit with Tubing", image:Img151}
        ]
  },
  {
    id: "ortho-care",
    name: "Orthopedic & Support Care",
    description:"High-quality orthopedic and rehabilitation products designed to support mobility, recovery, and injury management.",
    subcategories: [
      {
        id: 'abdominal-pain',
        name: 'Abdominal Pain and Injury Support',
        products: [
          { name: "Abdominal Binder Belt (Standard)", image: Img1 },
  { name: "Abdominal Support Belt (Double Strap)", image: Img2 },
  { name: "Abdominal Binder Belt (Wide Panel)", image: Img3 },
  { name: "Lumbar Support Belt (Elastic Compression)", image: Img4 },
  { name: "Post-Surgery Abdominal Support Belt", image: Img5 },
  { name: "Hernia Support Belt (Adjustable)", image: Img6 },
  { name: "Lumbar Support Belt (Slim Fit)", image: Img7 },
  { name: "Abdominal Binder Belt (Double Compression)", image: Img8 },
  { name: "Lumbar Support Belt (Basic Model)", image: Img9 }

        
        ]
      },
      {
        id: 'ankle-pain',
        name: 'Ankle Pain and Injury Support',
        products: [
        { name: "Elastic Ankle Wrap Support", image: Img10 },
  { name: "Adjustable Ankle Binder Strap", image: Img11 },
  { name: "Compression Ankle Support Socks (Black)", image: Img12 },
  { name: "Elastic Ankle Support Sleeve (Grey)", image: Img13 },
  { name: "Ankle Support Brace with Straps", image: Img14 },
  { name: "Ankle Foot Orthosis (AFO) Brace", image: Img15 }
        ]
      },
      {
        id: 'back-pain',
        name: 'Back pain and injury support',
        products: [
  { name: "Clavicle Brace Posture Corrector (Front Strap)", image: Img16 },
  { name: "Lumbar Support Belt (Slim Fit)", image: Img17 },
  { name: "Lumbar Corset Belt (Wide Panel)", image: Img18 },
  { name: "Lumbar Support Belt (Elastic Fit)", image: Img19 },
  { name: "Back Support Belt (Posture Corrector)", image: Img20 },
  { name: "Full Back Posture Corrector Brace", image: Img21 },
  { name: "Lumbar Support Belt (Basic Grey)", image: Img22 },
  { name: "Posture Corrector Belt (Cross Back Support)", image: Img23 }
]
      },
      {
        id: 'cervical-pain',
        name: 'Cervical pain and injury support',
        products: [
  { name: "Soft Cervical Collar (Foam Support - Beige)", image: Img24 },
  { name: "Hard Cervical Collar (Adjustable Support)", image: Img25 },
  { name: "Cervical Collar with Chin Support", image: Img26 },
  { name: "Soft Neck Support Collar (Ergonomic Fit)", image: Img27 }
]
      },
      {
        id: 'mid-body-pain',
        name: 'Chest, Rib & Shoulder pain and injury support',
        products: [
  { name: "Arm Sling Pouch Support", image: Img28 },
  { name: "Rib Support Belt (Elastic Chest Binder)", image: Img29 },
  { name: "Clavicle Brace (Shoulder Support)", image: Img30 },
  { name: "Abdominal & Rib Support Belt", image: Img31 },
  { name: "Chest Binder Support Belt", image: Img32 },
  { name: "Arm Sling Immobilizer Support", image: Img33 },
  { name: "Shoulder Immobilizer Brace", image: Img34 },
  { name: "Shoulder Support Wrap (Neoprene)", image: Img35 },
  { name: "Elbow Support Bandage Wrap", image: Img36 },
  { name: "Elbow Support Brace (Adjustable)", image: Img37 }
]
      },
      {
        id: 'elbow-pain',
        name: 'Elbow pain and injury support',
        products: [
  { name: "Elbow Support Sleeve (Compression)", image: Img38 },
  { name: "Elbow Support Brace with Strap", image: Img39 },
  { name: "Exercise Therapy Ball (Gel)", image: Img40 },
  { name: "Hot & Cold Gel Therapy Pack Set", image: Img41 }
]
      },
      {
        id: 'exercise-aid',
        name: 'Exercise Aid',
        products: [
  { name: "Acupressure Foot Insoles", image: Img42 },
  { name: "Plain Insoles (Diabetic Soft Cushion)", image: Img43 }
]
      },
      {
        id: 'foot-care',
        name: 'Foot Care',
       products: [
  { name: "Insole with Arch Support", image: Img44 },
  { name: "Orthopedic Comfort Shoes (Diabetic)", image: Img45 },
  { name: "Shoe Wearing Aid (Assist Device)", image: Img46 },
  { name: "Heel Care Socks (Silicone Support)", image: Img47 },
  { name: "Arch Support Pads (Foot Cushion)", image: Img48 },
  { name: "Toe Separator Gel Pads", image: Img49 },
  { name: "Orthopedic Support Sandals", image: Img50 },
  { name: "Medical Cotton Rolls (Sterile)", image: Img51 }
]
      },
      {
        id: 'fracture-aid',
        name: 'Foot Care',
       products: [
  { name: "Elastic Crepe Bandage Roll", image: Img52 },
  { name: "Arm Cast Support Sleeve", image: Img53 },
  { name: "Medical Gauze Roll Set", image: Img54 },
  { name: "Electro Therapy Pain Relief Device", image: Img55 },
  { name: "Electric Heating Pad (Heat Therapy)", image: Img56 }
]
      },
      {
        id: 'hot-cold-therapy',
        name: 'Hot and Cold Therapy',
        products: [
  { name: "Hot Water Bag (Rubber - Green)", image: Img57 },
  { name: "Printed Hot Water Bag (Soft Cover)", image: Img58 },
  { name: "Compression Ankle Support Sleeve", image: Img59 },
  { name: "Calf Support Compression Sleeve", image: Img60 }
]
      },
      {
        id: 'knee-pain',
        name: 'Knee pain and injury support',
        products: [
  { name: "Knee Compression Sleeve (Pair)", image: Img61 },
  { name: "Adjustable Knee Support (Strap Type)", image: Img62 },
  { name: "Elastic Knee Compression Sleeve (Grey)", image: Img63 },
  { name: "Knee Cap Support (Beige)", image: Img64 },

  { name: "Long Hinged Knee Brace", image: Img65 },
  { name: "Knee Immobilizer Brace (Full Length)", image: Img66 },
  { name: "Patella Support Knee Brace", image: Img67 },
  { name: "Open Patella Knee Support (Round Cap)", image: Img68 },

  { name: "Adjustable Hinged Knee Support", image: Img69 },
  { name: "Thigh Compression Support Sleeve", image: Img70 },
  { name: "Long Knee Immobilizer (Black)", image: Img71 },
  { name: "Full Leg Compression Support", image: Img72 },

  { name: "Multi-Position Body Support Pillow", image: Img73 },
  { name: "Orthopedic Knee Pillow (Leg Alignment Pillow)", image: Img74 }
]
      },
      {
        id: 'life-comfortable',
        name: 'Pillows and Cushions',
        products: [
  { name: "Ergonomic Lumbar Support Chair", image: Img75 },
  { name: "Posture Corrector Back Support Belt", image: Img76 },
  { name: "Lumbar Support Cushion (Back Rest Pillow)", image: Img77 },
  { name: "Neck Travel Pillow (U-Shaped)", image: Img78 },

  { name: "Full Body Support Pillow", image: Img79 },
  { name: "Wedge Support Pillow (Leg Elevation)", image: Img80 }
]
      },
      {
        id: 'wrist-pain',
        name: 'Wrist, Finger Pain and Injury Support',
        products: [
  { name: "Forearm & Wrist Immobilizer Brace (Long Type)", image: Img83 },
  { name: "Adjustable Wrist Support Strap (Black)", image: Img84 },

  { name: "Elbow Support Strap (Tennis Elbow Brace)", image: Img85 },
  { name: "Wrist Brace with Thumb Support (Adjustable)", image: Img86 },

  { name: "Abdominal Binder Belt (Support Belt)", image: Img87 },
  { name: "Finger Compression Support Glove", image: Img88 },

  { name: "Cotton Balls (Medical Grade Cotton)", image: Img89 },
  { name: "Gauze Roll (Absorbent Medical Dressing)", image: Img90 }
]
      },
    ]
  },
  {
    id: "hygiene-care",
    name: "Hygiene & Cotton Products",
    description:"Sterile and non-sterile hygiene consumables essential for maintaining cleanliness and infection control in healthcare environments.",
    products: [
  { name: "Adhesive Bandage Strips (Box Pack)", image: Img91 },
  { name: "Capsicum Pain Relief Plaster", image: Img92 },
  { name: "Crepe Bandage (Elastic Support Bandage)", image: Img93 },
  { name: "Cotton Earbuds (Cotton Swabs Jar)", image: Img94 },

  { name: "Face Wipes (Hygiene Wet Wipes)", image: Img95},
  { name: "First Aid Adhesive Bandage", image: Img96 },
  { name: "Gauze Roll (Absorbent Medical Roll)", image: Img97 },
  { name: "Gauze Balls (Sterile Cotton Gauze Balls)", image: Img98 },

  { name: "Gauze Bandage (Medical Dressing Bandage)", image: Img99 },
  { name: "Gauze Roll (Hospital Grade)", image: Img100 },
  { name: "Gauze Swabs (Sterile Dressing Pads)", image: Img101 },
  { name: "Gauze Swabs (Non-Sterile Pack)", image: Img102 },

  { name: "Laparotomy Sponges (Surgical Sponges)", image: Img103 },
  { name: "Makeup Removal Cotton Pads", image: Img104 },
  { name: "Cotton Roll (Absorbent Medical Cotton)", image: Img105 },
  { name: "Non-Woven Surgical Tape", image: Img106},
  { name: "Orthopedic Cotton Wrap (Padding Bandage)", image: Img107 },
{ name: "Orthopedic Casting Tape (Plaster Support Tape)", image: Img108 },

{ name: "Paraffin Wax (Therapy & Medical Use)", image: Img109 },
{ name: "Disposable Underpads (Absorbent Bed Pads)", image: Img110 },

{ name: "Wound Plasters (Adhesive Dressing Strips)", image: Img111 },
{ name: "Zigzag Cotton (Absorbent Cotton Pack)", image: Img112 }
  
    ]
//  , removed: Img113, Img114, Img115, Img116, Img117, Img118, Img119, Img120,
//   Img121, Img122, Img123, Img124
    
  },
  {
    id: "dressing-care",
    name: "Medical Dressings & Accessories",
    description:"Comprehensive range of wound care and dressing solutions for safe and effective patient recovery.",
    products: [
      { name: "Elastic Adhesive Bandage Set", image: Img113 },
{ name: "Crepe Bandage with Clip (Elastic Support)", image: Img114 },
{ name: "Elastic Bandage Roll (Medical Use)", image: Img115 },
{ name: "First Aid Dressing Kit (Complete Set)", image: Img116 },
      { name: "Gauze Bandage Rolls (Multi Pack)", image: Img117 },
{ name: "Absorbent Gauze Dressing Packs", image: Img118 },
{ name: "Sterile Gauze Swabs (Medical Pads)", image: Img119 },
{ name: "Combine Dressing Pads (Absorbent)", image: Img120 },
      { name: "Cotton Bandage Roll (Soft Roll Pack)", image: Img121 },
{ name: "Sterile Dressing Roll (Medical Gauze)", image: Img122 },
{ name: "Medical Gauze Roll Bandage", image: Img123 },
{ name: "Hospital Cotton Bandage Roll", image: Img124 },
      { name: "Surgical Dressing Kit (Sterile Pack)", image: Img125 },
{ name: "Instrument Tray Dressing Box", image: Img126 },
{ name: "Medical Adhesive Tape Roll", image: Img127 },
{ name: "Eye Pad Sterile Dressing", image: Img128 }
    ]
  },
  {
    id: "apparel-wear",
    name: "Apparel & Protective Wear",
    description:"Protective medical clothing and safety gear designed to ensure hygiene and safety for healthcare professionals.",
    products: [
      { name: "Medical Lab Coat (Doctor Coat)", image: Img161 },
{ name: "Disposable Surgical Cap (Bouffant Cap)", image: Img162 },

{ name: "Disposable Medical Gloves (Examination Gloves)", image: Img163 },
{ name: "Surgical Gown (Protective Hospital Wear)", image: Img164 },

{ name: "Face Shield (Protective Visor)", image: Img165 }
     
    ]
  },
  {
    id: "weighing-scales",
    name: "Weighing Scales & Measurement Devices",
    description:"Precision weighing and measurement solutions for accurate patient monitoring and diagnostics.",
    products: [
      { name: "Analog Weighing Scale (Round Dial)", image: Img154 },

{ name: "Digital Baby Weighing Scale", image: Img156 },
{ name: "Digital Glass Weighing Scale", image: Img157 },
{ name: "Baby Weighing Scale (Infant Scale Pack)", image: Img159 },

{ name: "Personal Bathroom Weighing Scale (Pink)", image: Img160 }
    //  Img154,
    // remove: Img155,
    //  Img156,
    //  Img157,
    // remove: Img158,
    //  Img159,
    //  Img160
    ]
  },
  {
    id: "surgical-instruments",
    name: "Surgical Instruments & Examination Tools",
    description:"Professional-grade surgical instruments and diagnostic tools for precision and reliability in medical procedures.",
    products: [
     
     { name: "Manual Blood Pressure Monitor (Sphygmomanometer Kit)", image: Img152 },
     { name: "Dual Head Acoustic Stethoscope", image: Img153 }
    ]
  },
  {
    id: "hospital-furniture",
    name: "Hospital Furniture & Infrastructure",
    description:"Durable and ergonomic hospital furniture solutions designed for patient comfort and efficient healthcare operations.",
        products: [
      { name: "Not finalized yet", image: Img134 },
{ name: "Not finalized yet", image: Img166},

{ name: "Not finalized yet", image: Img167},
{ name: "Not finalized yet", image: Img168 },

{ name: "Not finalized yet", image: Img169 },

      //  Img166,
      //  Img167,
      //  Img168,
      //  Img169,
      //  Img170
    ]
  }
];
